import updateCartIconQuantity from "./update-cart-icon";
import overlay from './loader';
import $ from "jquery";

$('.add-order-items-to-cart').click(function (event) {
    event.preventDefault();

    overlay(true);
    window.axios.post(window.config.urls.addOrderItemsToCart.replace(':order:', $(this).data('bs-order'))).then(({data: data}) => {
        if (data.success) {
            if (data.successText) {
                $('#add-order-items-to-cart-success-content').text(data.successText);
                $('#add-order-items-to-cart-success-container').show();
            } else {
                $('#add-order-items-to-cart-success-container').hide();
            }

            if (data.errorText) {
                $('#add-order-items-to-cart-error-content').text(data.errorText);
                $('#add-order-items-to-cart-error-container').show();
            } else {
                $('#add-order-items-to-cart-error-container').hide();
            }

            $('#addOrderItemsToCartModal').modal('show');
            updateCartIconQuantity();
        }
    }).finally(() => {
        overlay(false);
    });
})

$('.go-from-order-to-cart').click(function () {
    $('#addOrderItemsToCartModal').modal('hide');
    window.location.href = window.config.urls.cart;
})
